let BACKEND_API_PLACEHOLDER

if (import.meta.env.VITE_NODE_ENV == 'development') {
  if (import.meta.env.VITE_DEV_NETWORK_ACCESS === 'true') {
    BACKEND_API_PLACEHOLDER = '';
  }
  else BACKEND_API_PLACEHOLDER = import.meta.env.VITE_BACKEND_IP;
} else {
    BACKEND_API_PLACEHOLDER = "BACKEND_API_PLACEHOLDER";
}

export {
    BACKEND_API_PLACEHOLDER
}